export const about = {
label: 'ABOUT',
title: 'Built on Experience. Focused on Responsible Growth.',
subtitle: 'A Houston-based direct sales company focused on wellness, personal care, market development, and disciplined business operations.',
narrative_1: 'One More Global Inc. is an independent U.S. company focused on wellness, personal care, direct sales, and market development.',
narrative_2: 'Based in Houston, Texas, the company supports product distribution, customer relationships, independent distributor network development, strategic partnerships, and business operations across its active markets.',
narrative_3: 'Our approach combines product quality, operational discipline, market-specific execution, and long-term business relationships. We aim to grow responsibly while maintaining clear internal processes and consistent service standards.',
narrative_4: '',
mission_title: 'Our Mission',
mission_text: 'To provide quality wellness and personal care products through responsible direct sales, disciplined operations, sustainable market development, and strong relationships with customers, independent distributors, and business partners.',
values_title: 'Core Values',
value_1: 'Operational Excellence',
value_1_desc: 'Maintaining the highest standards in every aspect of regional operations.',
value_2: 'Strategic Growth',
value_2_desc: 'Pursuing sustainable expansion through careful market analysis and partnership development.',
value_3: 'International Alignment',
value_3_desc: 'Ensuring seamless coordination between regional operations and global strategic objectives.',
value_4: 'Corporate Integrity',
value_4_desc: 'Upholding transparent governance and ethical business practices across all operations.',
};
